module.exports = __webpack_public_path__ + "img/smd-logo.ac58e8fe.svg";